import * as React from 'react';
import { Provider } from 'react-redux';
import { createFormStore } from 'sos-eservice-common/js/Redux/store.provider';
import { map } from './stepValidationMap';
import { OmbudOrderProps } from './Ombud.types';
import OmbudForm from './OmbudForm';
import { OmbudConfig } from './ombudConfig';
import { setFormConfig } from 'sos-eservice-common/js/config';
import { getInitialState } from './init';
export class OmbudAnsokan extends React.Component<OmbudOrderProps, any> {
  private store: ReturnType<typeof createFormStore>;
  constructor(props) {
    super(props);

    const { translations, basePath } = this.props;
    setFormConfig(new OmbudConfig(translations, basePath, map));

    const initialState = getInitialState(this.props);
    this.store = createFormStore(initialState);
  }

  public render() {
    return (
      <Provider store={this.store}>
        <OmbudForm />
      </Provider>
    );
  }
}
